// extracted by mini-css-extract-plugin
export default {"videoBox":"HbYnGhYf72n0n_QCKto1","videoPreview":"jYOT25ST4UQeISQ7o30y","videoTitle":"Y8j_gfXbLScstN4a4q4V","fileLink":"HEPWNZ2UW1IAoKTy4YI1"};